import { Stack } from '@mui/material';
import { Edit } from './Edit';
import { CriteriaFilter } from './CriteriaFilter';
import { useIsDesktop } from 'Hooks';
import { useContext } from 'react';
import { SUPPLIERS_STEPS } from 'Enum/suppliers';
import { SuppliersContext } from 'Context/SuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

export const DynamicAdvancedCriteriaFilter = () => {
  const { setStepIndex } = useContext(SuppliersContext);
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      sx={{
        position: 'relative',
        p: isDesktop ? '16px 24px 16px 8px' : '6px 16px 8px 12px',
        height: isDesktop ? '64px' : '72px',
        bgcolor: '#FFFFFF',
        border: '1px solid',
        borderColor: 'purple2.main',
        borderRadius: '10px',
      }}
      onClick={
        isDesktop
          ? undefined
          : (event) => {
              event.stopPropagation();
              setStepIndex(SUPPLIERS_STEPS.FORM);
            }
      }
      role={isDesktop ? undefined : 'button'}
      aria-label={
        isDesktop ? undefined : Dictionary[DICTIONARY.Suppliers].resultPage.edit
      }
    >
      <CriteriaFilter />
      <Edit />
    </Stack>
  );
};
